import React from "react";
import PeopleIcon from "@mui/icons-material/People";
import FlightIcon from "@mui/icons-material/Flight";
import EventIcon from "@mui/icons-material/Event";
import { Skeleton } from "@mui/material";

export default function MetricsWidgetV2(props) {
  const renderIcon = (iconName) => {
    switch (iconName) {
      case "People":
        return (
          <PeopleIcon
            style={{
              fontSize: "30px",
              marginRight: "10px",
              backgroundColor: "#f3f4f6",
              paddingLeft: "10px",
              paddingRight: "10px",
              borderRadius: "50px",
              height: "40px",
              width: "40px",
            }}
          />
        );
      case "Flight":
        return (
          <FlightIcon
            style={{
              fontSize: "30px",
              marginRight: "10px",
              backgroundColor: "#f3f4f6",
              paddingLeft: "10px",
              paddingRight: "10px",
              borderRadius: "50px",
              height: "40px",
              width: "40px",
            }}
          />
        );
      case "Event":
        return (
          <EventIcon
            style={{
              fontSize: "30px",
              marginRight: "10px",
              backgroundColor: "#f3f4f6",
              paddingLeft: "10px",
              paddingRight: "10px",
              borderRadius: "50px",
              height: "40px",
              width: "40px",
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="metrics-widget-container-v2"
      style={{
        backgroundColor: props.backgroundColor,
        color: props.textColor,
        display: "flex",
        flexDirection: "row",
        // width: "100%",
        width: "180px",
      }}
    >
      <div
        style={{
          fontSize: "16px",
        }}
      >
        {renderIcon(props.iconName)}
      </div>

      <div>
        <div
          style={{
            width: "100%",
            height: "30%",
            textAlign: "start",
            fontSize: "16px",
            fontWeight: "600",
            color: props.textColor2,
          }}
        >
          {props.title}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            paddingBottom: "10px",
            justifyContent: "flex-start",
            alignContent: "flex-start",
            alignSelf: "flex-start",
          }}
        >
          <div
            style={{
              width: "150px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {props.isLoading ? (
              <Skeleton width={150} height={35} />
            ) : (
              <>
                <div
                  style={{
                    width: "20%",
                    textAlign: "start",
                    fontSize: "22px",
                    fontWeight: "700",
                    marginRight: "0px",
                  }}
                >
                  {props.value}
                </div>
                <div
                  style={{
                    width: "80%",
                    textAlign: "start",
                    fontSize: "22px",
                    lineHeight: "24px",
                    fontWeight: "700",
                  }}
                >
                  {props.title2}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
